<template>
  <div>
    <app-panel title="Фантомно показать квитанции">
      <div style="margin-bottom: 15px">
        <app-datepicker v-model="month" label="Месяц" format="MMMM yyyy" minimum-view="month" :danger.sync="isError" danger-text="Выберите месяц"/>
      </div>
      <div style="text-align: center">
        <app-button color="danger" style="margin-right: 15px" :disabled="isDeletingFines" @click="deleteFines">{{isDeletingFines ? 'Удаляю пени' : 'Удалить пени'}}</app-button>
        <app-button color="success" :disabled="isShowing" @click="show">{{isShowing ? 'Показываю' : 'Показать'}}</app-button>
      </div>
    </app-panel>
  </div>
</template>

<script>
  export default {
    name: "ShowInvoicesPanel",
    props: {
      importInfo: {}
    },
    data(){
      return {
        isShowing: false,
        month: null,
        isError: false,
        isDeletingFines: false,
      }
    },
    methods: {
      deleteFines(){
        if(this.month === null){
          this.isError = true;
          return false;
        }

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Подтверждение',
          text: 'Вы уверены что хотите удалить пени на выбранный месяц?',
          acceptText: 'Да',
          cancelText: 'Нет',
          accept: async () => {
            this.isDeletingFines = true;
            try {
              await this.$http.delete('import/houses/fines', {
                params: {
                  import_id: this.importInfo.id,
                  month: this.$options.filters.moment(this.month, 'YYYY-MM')
                }
              });
              this.$vs.notify({color: 'success', title: 'Успешное удаление', text: 'Пени удалены'});
            } catch (e) {
              this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
            }
            finally{
              setTimeout(() => {this.isDeletingFines = false}, 300)
            }
          }
        });
      },
      async show(){
        if(this.month === null){
          this.isError = true;
          return false;
        }
        try{
          this.isShowing = true;
          let body = {
            import_id: this.importInfo.id,
            month: this.$options.filters.moment(this.month, 'YYYY-MM')
          };
          await this.$http.put('import/houses/phantom_show_kv', body);
          setTimeout(() => {
            this.isShowing = false;
            this.$vs.notify({color: 'success', title: 'Успешно', text: 'Квитанции показаны'});
          }, 300);
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.isShowing = false;
        }
      }
    }

  }
</script>

<style lang="scss">

</style>